import MarkdownText from '@/components/markdown/markdown-text';
import { Box, Button, IconInfoCircle, IconX, Image } from '@cmpsr/components';

interface ComparisonModalContentProps {
  onClose: () => void;
  includedContent: string;
  traditionalContent: string;
}

export const ComparisonModalContent = ({
  onClose,
  includedContent,
  traditionalContent,
}: ComparisonModalContentProps) => {
  return (
    <Box maxWidth="400px" bg="tan" borderRadius="10px">
      <Box display="flex" justifyContent="center" mb="spacer-10" flexDirection="column" gap="spacer-0">
        <Box display="flex" justifyContent="flex-end" mt="spacer-4">
          <Button variant="primary" size="l" onClick={onClose} backgroundColor="lightBlue" p="3" color="darkBlue">
            <IconX w="20px" size="l" color="darkBlue" />
          </Button>
        </Box>
        <Box
          width="36px"
          height="36px"
          borderRadius="8px"
          bg="gradient.dark"
          display="flex"
          alignItems="center"
          justifyContent="center"
          alignSelf="center"
        >
          <IconInfoCircle w="20px" size="m" color="white" />
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" gap="spacer-10">
        <Box display="flex" gap="spacer-5" alignItems="start">
          <Image w="22px" h="auto" src="/images/green-check-egg.svg" alt="green check egg" />
          <MarkdownText fontSize="14px" lineHeight="1.4" color="darkBlue">
            {includedContent}
          </MarkdownText>
        </Box>

        <Box display="flex" gap="spacer-5" alignItems="start">
          <Image w="22px" h="auto" src="/images/red-x-egg.svg" alt="red x egg" />
          <MarkdownText fontSize="14px" lineHeight="1.4" color="darkBlue">
            {traditionalContent}
          </MarkdownText>
        </Box>
      </Box>

      <Box display="flex" justifyContent="center" mt="spacer-10">
        <Button variant="primary" size="m" onClick={onClose} backgroundColor="lightBlue" py="5" px="8" color="darkBlue">
          Ok, Got It!
        </Button>
      </Box>
    </Box>
  );
};
